import { areCookiesAuthorized, combine, canUseEventBridge, getEventBridge, startInternalMonitoring, startBatchWithReplica, } from '@datadog/browser-core';
import { startLogsSessionManager, startLogsSessionManagerStub } from '../domain/logsSessionManager';
import { buildAssemble, getRUMInternalContext } from '../domain/assemble';
import { startConsoleCollection } from '../domain/logsCollection/console/consoleCollection';
import { startReportCollection } from '../domain/logsCollection/report/reportCollection';
import { startNetworkErrorCollection } from '../domain/logsCollection/networkError/networkErrorCollection';
import { startRuntimeErrorCollection } from '../domain/logsCollection/runtimeError/runtimeErrorCollection';
export function startLogs(configuration, sender) {
    var internalMonitoring = startLogsInternalMonitoring(configuration);
    internalMonitoring.setExternalContextProvider(function () {
        var _a;
        return combine({ session_id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id }, getRUMInternalContext(), {
            view: { name: null, url: null, referrer: null },
        });
    });
    internalMonitoring.setTelemetryContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    startNetworkErrorCollection(configuration, sender);
    startRuntimeErrorCollection(configuration, sender);
    startConsoleCollection(configuration, sender);
    startReportCollection(configuration, sender);
    var session = areCookiesAuthorized(configuration.cookieOptions) && !canUseEventBridge()
        ? startLogsSessionManager(configuration)
        : startLogsSessionManagerStub(configuration);
    return doStartLogs(configuration, session, sender);
}
function startLogsInternalMonitoring(configuration) {
    var _a, _b;
    var internalMonitoring = startInternalMonitoring(configuration);
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return bridge_1.send('internal_log', message); });
        internalMonitoring.telemetryEventObservable.subscribe(function (message) { return bridge_1.send('internal_telemetry', message); });
    }
    else {
        if (configuration.internalMonitoringEndpointBuilder) {
            var batch_1 = startBatchWithReplica(configuration, configuration.internalMonitoringEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.internalMonitoringEndpointBuilder);
            internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return batch_1.add(message); });
        }
        var monitoringBatch_1 = startBatchWithReplica(configuration, configuration.rumEndpointBuilder, (_b = configuration.replica) === null || _b === void 0 ? void 0 : _b.rumEndpointBuilder);
        internalMonitoring.telemetryEventObservable.subscribe(function (event) { return monitoringBatch_1.add(event); });
    }
    return internalMonitoring;
}
export function doStartLogs(configuration, sessionManager, sender) {
    var _a;
    var assemble = buildAssemble(sessionManager, configuration, sender);
    var onLogEventCollected;
    if (canUseEventBridge()) {
        var bridge_2 = getEventBridge();
        onLogEventCollected = function (message) { return bridge_2.send('log', message); };
    }
    else {
        var batch_2 = startBatchWithReplica(configuration, configuration.logsEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.logsEndpointBuilder);
        onLogEventCollected = function (message) { return batch_2.add(message); };
    }
    return {
        send: function (message, currentContext) {
            var contextualizedMessage = assemble(message, currentContext);
            if (contextualizedMessage) {
                onLogEventCollected(contextualizedMessage);
            }
        },
    };
}
//# sourceMappingURL=startLogs.js.map